import(/* webpackMode: "eager" */ "/vercel/path0/src/app/assignments/page.tsx");
